import type * as RcuBindingsBundle from '@foundation-player/plugin-rcu-bindings';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createRcuBindingsPlugin: PluginFactoryFunction = (builderConfig) => {
  const rcuBindingsPackage = PackageName.PluginRcuBindings;

  return [
    [rcuBindingsPackage],
    () => {
      const rcuBindingsGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[rcuBindingsPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof RcuBindingsBundle>(rcuBindingsPackage).RcuBindingsPlugin)(
          builderConfig.pluginConfigs[rcuBindingsGlobalName] as RcuBindingsBundle.PluginConfig,
        ),
      ];
    },
  ];
};
